import apiClient from '@u/apiClient'
import DeleteWikiItemController from '@/wayfinder/actions/App/Http/Controllers/WikiItem/DeleteWikiItemController'
import CreateItemForWikiItemControlleur from '@/wayfinder/actions/App/Http/Controllers/WikiItem/CreateItemForWikiItemControlleur'
import CreateWikiItemController from '@/wayfinder/actions/App/Http/Controllers/WikiItem/CreateWikiItemController'
import UpdateWikiItemController from '@/wayfinder/actions/App/Http/Controllers/WikiItem/UpdateWikiItemController'

let base_errors = { deceased: {}, events: [] }

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  async deleteWikiItemById({ commit }, payload) {
    await apiClient
      .route(
        DeleteWikiItemController.delete.delete({
          wiki_item_id: payload.wiki_item_id
        })
      )
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setItemList', {
            item_list: response.data.items,
            parent_is_a_place: payload.parent_is_a_place
          })
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('deleteWikiItemById', reason)
      })
  },
  async undoDeleteWikiItemById({ commit }, payload) {
    await apiClient
      .route(
        DeleteWikiItemController.undo.get({
          wiki_item_id: payload.wiki_item_id
        })
      )
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setItemList', {
            item_list: response.data.items,
            parent_is_a_place: payload.parent_is_a_place
          })
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('undoDeleteWikiItemById', reason)
      })
  },
  storeItemForWikiItem({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CreateItemForWikiItemControlleur.post({ wiki_item_id: payload.id }),
          payload.item
        )
        .then((response) => {
          if (response.status === 201) {
            resolve(response.data)
          }
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  storeWikiItem({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CreateWikiItemController.post({ place: payload.place_id }),
          payload.item
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  updateWikiItem({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateWikiItemController.put({ wiki_item: payload.wiki_item_id }),
          payload.item
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
